export { GenIcon, IconBase, SvgCss } from './IconBase.es.js';
export { DefaultContext, IconContext } from './IconContext.es.js';
import 'tslib';
import 'react';
import '@teko/styled';

const hasColoredIcon = (ele) => {
    var _a, _b;
    if (!ele)
        return false;
    return (_b = (_a = ele === null || ele === void 0 ? void 0 : ele.type) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.endsWith('Colored');
};

export { hasColoredIcon };
